/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./niota.vue?vue&type=template&id=28d9192c&scoped=true"
import script from "./niota.vue?vue&type=script&lang=js"
export * from "./niota.vue?vue&type=script&lang=js"
import style0 from "./niota.vue?vue&type=style&index=0&id=28d9192c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d9192c",
  null
  
)

export default component.exports